import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "flowObjectTypeId", "actionId"];
import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import CreateTaskActionMetadata from 'automation-ui-action-features/actions/create-task/records/CreateTaskActionMetadata';
import CreateTaskActionSummary from 'automation-ui-action-features/actions/create-task/CreateTaskActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function CreateTaskActionCard(_ref) {
  let {
      getHeaderTitle,
      actionMetadata,
      flowObjectTypeId,
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId: actionId
    }),
    content: /*#__PURE__*/_jsx(CreateTaskActionSummary, {
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    })
  }));
}
CreateTaskActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionMetadata: PropTypes.instanceOf(CreateTaskActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default CreateTaskActionCard;